import React, { useEffect, useState } from "react";
import { getClinic } from "../lib/api";

const ClinicContext = React.createContext(null);

export const ClinicProvider = ({ children }) => {
  const [data, setData] = useState({ clinic: null, pricing: null });

  useEffect(() => {
    getClinic().then(setData).catch(() => {});
  }, []);

  return (
    <ClinicContext.Provider value={data}>{children}</ClinicContext.Provider>
  );
};

export const useClinic = () => React.useContext(ClinicContext) || {};
